module.exports = __webpack_public_path__ + "img/total-sponsor-icon.8894a45f.svg";